var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFollow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.56883 4.11496C7.46486 3.3358 8.57815 3 9.50001 3C10.4219 3 11.5352 3.3358 12.4312 4.11496C13.3573 4.92025 14 6.15566 14 7.82609C14 10.7793 11.9003 13 9.50001 13C7.09969 13 5 10.7793 5 7.82609C5 6.15565 5.64275 4.92024 6.56883 4.11496ZM7.88118 5.62417C7.40726 6.03628 7 6.71391 7 7.82609C7 9.88157 8.40033 11 9.50001 11C10.5997 11 12 9.88158 12 7.82609C12 6.71391 11.5927 6.03628 11.1188 5.62417C10.6149 5.18594 9.97815 5 9.50001 5C9.02188 5 8.38515 5.18594 7.88118 5.62417Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 14C4.50313 14 2 15.6086 2 18.5117C2 19.8885 5.35625 21 9.5 21C13.6437 21 17 19.8885 17 18.5117C17 15.6086 14.4969 14 9.5 14ZM4.04061 18.046C4.21248 18.1401 4.46813 18.2553 4.82557 18.3738C5.92944 18.7398 7.58192 19 9.5 19C11.4181 19 13.0706 18.7398 14.1744 18.3738C14.5319 18.2553 14.7875 18.1401 14.9594 18.046C14.8629 17.5447 14.5891 17.1847 14.08 16.8732C13.2855 16.3871 11.8419 16 9.5 16C7.15813 16 5.71453 16.3871 4.91997 16.8732C4.41091 17.1847 4.13708 17.5447 4.04061 18.046ZM15.2159 17.874L15.2149 17.875L15.2086 17.881C15.2131 17.8763 15.2159 17.874 15.2159 17.874Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M18 13V16H20V13H23V11H20V8H18V11H15V13H18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollow);
export default __webpack_public_path__ + "static/media/follow.3deda7ff686308f26705ebd34ad5c573.svg";
export { ForwardRef as ReactComponent };